import { render, staticRenderFns } from "./AutoplayVideo.vue?vue&type=template&id=791f9bd8&"
import script from "./AutoplayVideo.vue?vue&type=script&lang=js&"
export * from "./AutoplayVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports